import React from 'react';
import { Trans } from '@lingui/react';

import Link from '../../core/Link/Link';
import Paragraph from '../../core/Paragraph/Paragraph';
import Text, { Props as TextProps } from '../../core/Text/Text';

import {
  TextWithSingleInlineLinkProps,
  validateParagraphText,
} from './TextWithSingleInlineLink.common';

export type Props = TextWithSingleInlineLinkProps & Omit<TextProps, 'children' | 'as'>;

const TextWithSingleInlineLink: React.FC<Props> = ({
  asParagraph = false,
  paragraphText,
  href,
  target,
  size,
  textColor,
  variant,
  underline,
  fontWeight,
  linkFontWeight,
  onClick,
  ...textProps
}) => {
  validateParagraphText(paragraphText);
  const TypogComponent = asParagraph ? Paragraph : Text;
  return (
    <TypogComponent size={size} fontWeight={fontWeight} textColor={textColor} {...textProps}>
      <Trans
        id={paragraphText}
        message={paragraphText}
        components={[
          // @ts-expect-error
          <Link
            href={href}
            target={target}
            asInlineLink
            size={size}
            underline={underline}
            fontWeight={linkFontWeight || fontWeight}
            variant={variant}
            onClick={onClick}
            key={paragraphText}
          />,
        ]}
      />
    </TypogComponent>
  );
};

export default TextWithSingleInlineLink;
